import orderBy from 'lodash.orderby';

import type { CompanyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import type { InvoiceBatchQuerySchema } from '../shared/schemas/invoice-batch';
import type { InvoiceQuerySchema } from '../shared/schemas/invoices/invoice-query-schema';

export function tableConverter(
  data: InvoiceBatchQuerySchema[],
  loadedBatchInvoices: Record<string, InvoiceQuerySchema[]> = {}
) {
  const tableData = data.map((row) => {
    const invoices = loadedBatchInvoices[String(row.id)] ?? [];

    return {
      isBatch: true,
      id: row.id,
      name: row?.name ?? '—',
      invoice_number: '—',
      invoice_date: '—',
      invoice_amount: '—' as string | number,
      due_date: '—',
      client: null as CompanyQueryLinkerSchema | null,
      brand: invoices[0]?.brand ?? null,
      status: null,
      invoices_creation_date: row.invoices_creation_date,

      invoices: orderBy(
        invoices.map((invoice) => ({
          ...invoice,
          isBatch: false as const,
          name: '—',
          invoices_creation_date: '—',
        })),
        'client.name',
        'asc'
      ),
    };
  });

  return tableData;
}

/** Expandable batch row (has nested `invoices`). */
export type TableBatchParentRow = ReturnType<typeof tableConverter>[number];

/** Invoice line under a batch (no `invoices` array). */
export type TableBatchChildRow = NonNullable<TableBatchParentRow['invoices']>[number];

/** Any row rendered in the batch invoice data table. */
export type TableReturnType = TableBatchParentRow | TableBatchChildRow;
